import { WITNESS_API_BASE } from './console-env';
import { ApiNotConfiguredError } from './witness-api';

export interface TrustedLocation {
  storeNumber: string; name: string; street: string; city: string; state: string; zip: string;
  emailToPrint: string; distanceText: string; durationText: string | null;
  openHint: string; isOpenNow: boolean;
}

export function validSubjectZip(zip: string) { return /^\d{5}(?:-\d{4})?$/.test(zip.trim()); }

/** The same real location endpoint used by the trial; no geolocation request. */
export async function findTrustedLocations(zip: string, signal?: AbortSignal): Promise<TrustedLocation[]> {
  if (!validSubjectZip(zip)) throw new Error('Enter a five-digit US ZIP code, optionally followed by ZIP+4.');
  if (!WITNESS_API_BASE) throw new ApiNotConfiguredError();
  const response = await fetch(`${WITNESS_API_BASE}/locations/ups/nearby?${new URLSearchParams({ zip: zip.trim() })}`, { signal });
  if (response.status === 422) throw new Error('That ZIP code could not be found. Check it and try again.');
  if (!response.ok) throw new Error('Locations could not be loaded. Try again or enter the delivery email manually.');
  const body = await response.json() as { results: TrustedLocation[] };
  return body.results;
}
